import lodashKeyBy from 'lodash.keyby';

function GoalMatcher (profileMatcher, fromGoals, toGoals) {
    function makeGoalKey (profileId, goalXid) {
        return `${profileId}-${goalXid}`;
    }

    const fromGoalsMap = lodashKeyBy(fromGoals, 'id');
    const toGoalsMap = lodashKeyBy(toGoals, (goal) => makeGoalKey(goal.profile_id, goal.xid));

    return {
        match (fromGoalId) {
            const fromGoal = fromGoalsMap[fromGoalId];
            if (fromGoal) {
                const toProfile = profileMatcher.match(fromGoal.profile_id);
                if (toProfile) {
                    const toGoal = toGoalsMap[makeGoalKey(toProfile.id, fromGoal.xid)];
                    return toGoal || null;
                }
            }
            return null;
        }
    };
}

export default GoalMatcher;
